// Setting toggle for rightSideBar

export const GET_TOGGLE_RIGHT_SIDE_BAR = "GET_TOGGLE_RIGHT_SIDE_BAR";
export const SET_TOGGLE_RIGHT_SIDE_BAR = "SET_TOGGLE_RIGHT_SIDE_BAR";
